// export function buildQuery(params: { [key: string]: string | number | undefined }): string {
//   const queryObj: { [key: string]: string } = {};

//   for (const [key, value] of Object.entries(params)) {
//     if (value !== undefined && value !== "") {
//       queryObj[key] = value.toString();
//     }
//   }

//   return JSON.stringify(queryObj);
// }

export function buildQuery(params: { [key: string]: string | number | undefined }): string {
  const queryObj: { [key: string]: any } = {};

  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== "") {
      const stringValue = value.toString().trim();
      if (stringValue.includes(" OR ")) {
        const parts = stringValue.split(/\sOR\s/);
        const values = parts.map((part) => part.trim().replace(/"/g, ""));
        queryObj[key] = { $in: values };
      } else if (stringValue.includes(" AND ")) {
        const parts = stringValue.split(/\sAND\s/);
        const values = parts.map((part) => part.trim().replace(/"/g, ""));
        queryObj[key] = { $all: values };
      } else {
        queryObj[key] = stringValue.replace(/"/g, "");
      }
    }
  }

  console.log("Final query object:", queryObj);
  return JSON.stringify(queryObj);
}

export function buildSearchQuery(searchValue: string, keys: string[]): any {
  const words = searchValue.split(" ");
  const orClauses = keys.map((key) => {
    return {
      [key.toLowerCase()]: {
        $regex: words.join("|"),
        $options: "i",
      },
    };
  });
console.log("Final query object:", { $or: orClauses });
  return JSON.stringify({ $or: orClauses });
}
